<app-base-page title="Password changed" icon="check">
    <p class="mb-30">Now you can login to your account with new password</p>

    <div class="actions">
        <button routerLink="/login" mat-raised-button color="accent" class="u-button h-38 block">
            Login to your account
        </button>
    </div>
</app-base-page>
